import React from 'react';
import { AccentButton } from '../Button';

const ConfirmationPopup = ({
  onClose,
  onConfirm,
  icon,
  iconAlt,
  title,
  description,
  cancelLabel = 'Cancel',
  confirmLabel = 'Yes, delete it',
  confirmVariant = 'orange',
  error = null,
  isLoading = false,
}) => {
  // Do NOT call onClose here — let the caller decide when to close
  // (they need to handle async errors first)
  const handleConfirm = () => {
    onConfirm?.();
  };

  const handleCancel = () => {
    onClose?.();
  };

  return (
    <div
      className="
        w-[320px]
        bg-white dark:bg-[#121212]
        border border-[#ECECEC] dark:border-[#202020]
        rounded-[32px]
        shadow-[0_26px_38px_0_rgba(18,18,18,0.05)]
        flex flex-col
        relative
        mx-4
      "
    >
      {/* Icon - 80x80px, positioned at y: -40 (overlapping top section) */}
      <div className="absolute top-[-40px] left-1/2 transform -translate-x-1/2 z-10">
        <img 
          src={icon}
          alt={iconAlt}
          className="w-[80px] h-[80px]"
        />
      </div>

      {/* Top Section */}
      <div className="relative flex flex-col items-center pt-[40px] pb-0 px-0 bg-white dark:bg-[#121212] rounded-t-[32px]">

        {/* Text Content - starts 24px below icon */}
        <div className="flex flex-col items-center px-[30px] mt-[24px] mb-[24px]">
          {/* Title */}
          <h2
            className="
              font-medium text-2xl leading-8 tracking-[-0.173px]
              text-center
              text-[#121212] dark:text-[#D0D0D0]
              mb-[8px]
            "
          >
            {title}
          </h2>

          {/* Description */}
          <p
            className="
              text-xs leading-4 tracking-[-0.086px]
              text-center
              text-[#7B7B7B] dark:text-[#848484]
            "
          >
            {description}
          </p>

          {/* Inline error (e.g. folder not empty) */}
          {error && (
            <p
              className="
                mt-3 text-xs leading-4 text-center
                text-[#EF4444]
                bg-[#FEF2F2] dark:bg-[#2A1515]
                border border-[#FECACA] dark:border-[#7F1D1D]
                rounded-xl px-3 py-2
              "
            >
              {error}
            </p>
          )}
        </div>
      </div>

      {/* Bottom Section */}
      <div
        className="
          flex items-center justify-between
          px-[24px] py-[24px]
          h-[84px]
          bg-[#FCFCFC] dark:bg-[#1A1A1A]
          border-t border-[#ECECEC] dark:border-[#202020]
          rounded-b-[32px]
        "
      >
        {/* Cancel Button */}
        <AccentButton
          variant="secondary"
          onClick={handleCancel}
          disabled={isLoading}
          className="w-[130px] h-[36px]"
        >
          {cancelLabel}
        </AccentButton>

        {/* Confirm Button */}
        <AccentButton
          variant={confirmVariant}
          onClick={handleConfirm}
          disabled={isLoading}
          className="w-[130px] h-[36px]"
        >
          {isLoading ? 'Deleting…' : confirmLabel}
        </AccentButton>
      </div>
    </div>
  );
};

export default ConfirmationPopup;
